@if (isCostIndicatorCode) {
    <budget-balance-table [config]="config" />
} @else {
    <energy-balance-table [config]="config" />
}
